import { Box, Card, CardActions, CardContent, Grid, Stack } from "@mui/material";

import {
    required, ReferenceManyField, SingleFieldList, Edit,
    Toolbar,
} from "react-admin";


import { UserEditButtonsToolbar } from './UserEditButtonsToolbar';


import ImageFieldExtWithLink from "@/src/components/ImageFieldExtWithLink";
import { photoUrl } from "@/src/services";

import { SectionUserEditAccountInfo, SectionUserEditCredits, SectionUserEditLocation, SectionUserEditProfileInfo, SectionUserEditSettings } from "./Sections";

import { SafeUpdateForm } from "@/src/components";





export const UserEdit = () => {
    return (
        <SafeUpdateForm EditOrCreate={(props) =>
            <Edit {...props} actions={
                <UserEditButtonsToolbar />
            } />
        }>
            <UserFormConent />
        </SafeUpdateForm>

    )
};

const UserFormConent = () => {
    return (
        <Card>
            <CardContent>
                <Stack spacing={1}>
                    <ReferenceManyField filter={{ moderation: 'accepted' }} source="id"
                        reference="photo" target="user">
                        <SingleFieldList linkType={false}>
                            <ImageFieldExtWithLink source="id" label="Image"
                                getSrc={(photo: any) => photoUrl(photo, 'full')} />
                        </SingleFieldList>
                    </ReferenceManyField>
                
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, sm: 12, md: 6 }}>
                            <Grid container spacing={2}>
                                <Grid size={12}>
                                    <SectionUserEditAccountInfo />

                                </Grid>
                                <Grid size={12}>
                                    <SectionUserEditCredits />
                                </Grid>
                                <Grid size={12}>
                                    <SectionUserEditSettings />
                                </Grid>
                                <Grid size={12}>
                                    <SectionUserEditLocation />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid size={{ xs: 12, sm: 12, md: 6 }}>
                            <SectionUserEditProfileInfo />
                        </Grid>
                    </Grid>   
                </Stack>
            </CardContent>
            <Toolbar />

        </Card>
    )

}
